import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

function RangeProgressBar({ value }) {
  let variant, label;
  
  if (value >= 1 && value <= 4) {
    variant = 'success';
    label = 'Low';
  } else if (value >= 5 && value <= 9) {
    variant = 'warning';
    label = 'Normal';
  } else if (value >= 10) {
    variant = 'danger';
    label = 'High';
  }

  return (
<div >
<ProgressBar variant={variant}  now={value * 10} label={label} className='mb-3' />
</div>

  );
}

export default RangeProgressBar;
